module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-precomposed-a64ddb2ae616a475ba11b7916b9605f6.png";